import React, { useEffect, useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Api } from '../../../api/api';
import { endPoints } from '../../../api/apiEndpoints';
import logo from '../../../assets/img/logo/logo.png';
import ButtonCom from '../../../components/button/ButtonCom';
import InputControl from '../../../components/input/InputControl';
import AppBar from '@material-ui/core/AppBar';
import Tab from '@material-ui/core/Tab';
import Tabs from '@material-ui/core/Tabs';
import { useTheme } from '@mui/material/styles';
import SwipeableViews from 'react-swipeable-views';
import { colors, fonts } from '../../../utils';
import {
	Box,
	InputAdornment,
	IconButton,
	FormControl,
	InputLabel,
	FilledInput,
	CircularProgress,
} from '@mui/material';
import { Visibility, VisibilityOff } from '@mui/icons-material';
import { MHeading, MarginHandler, Flex } from '../../../styledComponents';
import { errorNotify, successNotify } from '../../../utils/helper';

const { colorWhite, colorPrimary, colorLightBlack } = colors;
const { primaryFont } = fonts;

function TabPanel(props) {
	const { children, value, index, ...other } = props;

	return (
		<div
			role='tabpanel'
			hidden={value !== index}
			id={`full-width-tabpanel-${index}`}
			aria-labelledby={`full-width-tab-${index}`}
			{...other}>
			{value === index && <Box sx={{ p: 3 }}>{children}</Box>}
		</div>
	);
}

function a11yProps(index) {
	return {
		id: `full-width-tab-${index}`,
		'aria-controls': `full-width-tabpanel-${index}`,
	};
}

const tabStyle = {
	fontSize: '1.6rem',
	color: colorWhite,
	fontFamily: primaryFont,
	textTransform: 'none',
};

const ForgetPassword = () => {
	const navigate = useNavigate();
	const theme = useTheme();
	const [value, setValue] = useState(0);
	const [disable, setDisable] = useState(true);
	const handleChange = (event, newValue) => {
		setValue(newValue);
	};

	const handleChangeIndex = (index) => {
		setValue(index);
	};

	const [email, setEmail] = useState('');
	const [validEmail, setValidEmail] = useState(false);
	const [invalidEmail, setInvalidEmail] = useState('');

	const [otp, setOtp] = useState('');
	const [validOtp, setValidOtp] = useState(false);
	const [invalidOtp, setInvalidOtp] = useState('');

	const [newPass, setNewPass] = useState('');
	const [validNewPass, setValidNewPass] = useState(false);
	const [invalidNewPassMsg, setInvalidNewPassMsg] = useState('');

	const [confirmPass, setConfirmPass] = useState('');
	const [validConfirmPass, setValidConfirmPass] = useState(false);
	const [invalidConfirmMsg, setInvalidConfirmMsg] = useState('');

	const [isError, setIsError] = useState('');

	const [showPassword, setShowPassword] = useState(false);

	const [confirmShowPassword, setConfirmShowPassword] = useState(false);

	const [dataLoader, setDataLoader] = useState(false);

	const handleClickShowPassword = () => {
		setShowPassword((prevState) => !prevState);
	};

	const handleClickConfirmShowPassword = () => {
		setConfirmShowPassword((prevState) => !prevState);
	};

	useEffect(() => {
		if (!email) {
			setValidEmail(false);
		}
		if (email) {
			setValidEmail(true);
		}
		if (validEmail) {
			setInvalidEmail('');
		}
	}, [email, invalidEmail, validEmail]);

	useEffect(() => {
		if (!otp) {
			setValidOtp(false);
		}
		if (otp) {
			setValidOtp(true);
		}
		if (validOtp) {
			setInvalidOtp('');
		}
	}, [otp, invalidOtp, validOtp]);

	useEffect(() => {
		if (!newPass) {
			setValidNewPass(false);
		}
		if (newPass) {
			setValidNewPass(true);
		}
		if (validNewPass) {
			setInvalidNewPassMsg('');
		}
	}, [newPass, invalidNewPassMsg, validNewPass]);

	useEffect(() => {
		if (!confirmPass) {
			setValidConfirmPass(false);
		}
		if (confirmPass) {
			setValidConfirmPass(true);
		}
		if (validConfirmPass) {
			setInvalidConfirmMsg('');
		}
	}, [confirmPass, invalidConfirmMsg, validConfirmPass]);

	const submitHandler = async (e) => {
		e.preventDefault();
		const v1 = validEmail;
		if (!v1) {
			setInvalidEmail('Email is required');
		}
		if (v1) {
		setDataLoader(true);
			Api?.post(`${endPoints?.auth?.verifyEmail}/${email}`)

				.then((d) => {
					successNotify(d?.data?.message);
					if (d) {
						setValue(1);
						setDisable(true);
					}
					setDataLoader(false);
				})
				.catch((error) => {
					setDataLoader(false);
					errorNotify(error?.response?.data?.message);
					setValue(0);
					setDisable(false);
				});
		}
	};

	const submitHandlerOTP = async (e) => {
		e.preventDefault();

		const v2 = validOtp;

		if (!v2) {
			setInvalidOtp('OTP is required');
		}
		if (v2) {
			setDataLoader(true);
			Api?.post(`${endPoints?.auth?.verifyOtp}?email=${email}&otp=${otp.trim()}`)

				.then((d) => {
					successNotify(d?.data?.message);
					setTimeout(function () {
						if (d) {
							setValue(2);
							setDisable(true);
						}
					}, 2000);
					setDataLoader(false);
				})
				.catch((error) => {
					setDataLoader(false);
					errorNotify(error?.response?.data?.message);
					setValue(1);
					setDisable(false);
				});
		}
	};

	const submitHandlerForgetPassword = async (e) => {
		e.preventDefault();
		const v3 = validNewPass;
		const v4 = validConfirmPass;

		if (!v3) {
			setInvalidNewPassMsg('New Password is required');
		}

		if (!v4) {
			setInvalidConfirmMsg('Confirm Password is required');
		}

		if (newPass !== confirmPass) {
			setIsError('Password and Confirm Password does not match.');
		} else {
			setIsError('');
		}
		const data = {
			email: email,
			newPassword: newPass,
			confirmPassword: confirmPass,
			otp: otp,
		};

		if (v3 && v4 && newPass === confirmPass) {
			setDataLoader(true);
			Api?.post(endPoints?.auth?.forgetPassword, data)
				.then((d) => {
					successNotify('Password changed successfully.');
					setTimeout(function () {
						navigate('/login');
					}, 2000);
					setDataLoader(false);
				})
				.catch((error) => {
					setDataLoader(false);
					errorNotify(error?.response?.data?.message);
				});
		}
	};

	const limit = 20;
	return (
		<>
			<div className='forget-wrapper'>
				{/* <div className='left'>
					<img src='/static/media/bg.afd7e64b3a3b9ae0dd88.jpg' alt='logo' />
				</div> */}
				<div className='right'>
					<div className='forget-pass-card'>
						{/* <Flex jc='center' mb='2rem' className='custom_logo'>
							<img src={logo} alt='ZUE USA' />
						</Flex> */}
						<MHeading fs='1.8rem' mb='0.5rem' className='font-face-M'>
							Forget Password
						</MHeading>

						<Box
							className='custom_box'
							sx={{ bgcolor: 'background.paper', width: '100%', margin: '3rem 0' }}>
							{dataLoader ? (
								<>
									<div
										className='custom_box_loader'
										style={{
											position: 'absolute',
											top: '50%',
											left: '50%',
											transform: 'translate(-50%, -50%)',
											width: '100%',
											height: '100%',
											background: '#00000036',
											display: 'flex',
											zIndex: '1',
										}}>
										<Flex
											jc='center'
											ai='center'
											style={{
												width: '100%',
											}}>
											<CircularProgress
												color='primary'
												style={{ fontSize: '2.5rem' }}
											/>
										</Flex>
									</div>
								</>
							) : (
								''
							)}
							<AppBar position='static'>
								<Tabs
									value={value}
									onChange={handleChange}
									TabIndicatorProps={{
										style: {
											backgroundColor: colorPrimary,
										},
									}}
									style={{
										backgroundColor: colorLightBlack,
										position: 'relative',
									}}
									sx={{
										'&.MuiTabs-root': {
											// height: '4.8rem !important',
											display: 'flex',
											justyifyContent: 'center',
											alignItems: 'center',
										},
									}}
									textColor='inherit'
									variant='fullWidth'>
									<Tab
										disabled='true'
										label={<span style={tabStyle}>Verify Email</span>}
										{...a11yProps(0)}
									/>
									<Tab
										disabled='true'
										label={<span style={tabStyle}>Verify OTP</span>}
										{...a11yProps(1)}
									/>
									<Tab
										disabled='true'
										label={<span style={tabStyle}>Forget password</span>}
										{...a11yProps(2)}
									/>
								</Tabs>
							</AppBar>
							<SwipeableViews
								axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
								index={value}
								onChangeIndex={handleChangeIndex}>
								<TabPanel value={value} index={0} dir={theme.direction}>
									<form onSubmit={submitHandler}>
										<MarginHandler mb='2rem'>
											<InputControl
												label='Email'
												name='email'
												state={email}
												type='email'
												onChange={(e) => setEmail(e.target.value)}
												errorMsg={invalidEmail && invalidEmail}
												error={invalidEmail?.length > 0}
											/>
										</MarginHandler>
										<ButtonCom type='submit' btnTitle='Verify Email' />
									</form>
								</TabPanel>
								<TabPanel value={value} index={1} dir={theme.direction}>
									<form onSubmit={submitHandlerOTP}>
										<MarginHandler mb='2rem'>
											<InputControl
												label='OTP'
												name='otp'
												state={otp}
												type='text'
												onChange={(e) => setOtp(e.target.value)}
												errorMsg={invalidOtp && invalidOtp}
												error={invalidOtp?.length > 0}
											/>
										</MarginHandler>
										<ButtonCom type='submit' btnTitle='Verify OTP' />
									</form>
								</TabPanel>
								<TabPanel value={value} index={2} dir={theme.direction}>
									<form onSubmit={submitHandlerForgetPassword}>
										<MarginHandler mb='2rem' className='toggle_cover'>
											<InputControl
												label='New Password'
												name='newPass'
												state={newPass}
												type={showPassword ? 'text' : 'password'}
												onChange={(e) =>
													setNewPass(e.target.value.slice(0, limit))
												}
												errorMsg={invalidNewPassMsg && invalidNewPassMsg}
												error={invalidNewPassMsg?.length > 0}
											/>
											<IconButton
												className='toggle_btn'
												aria-label='toggle password visibility'
												onClick={handleClickShowPassword}
												edge='end'>
												{showPassword ? <VisibilityOff /> : <Visibility />}
											</IconButton>
										</MarginHandler>
										<MarginHandler mb='2rem' className='toggle_cover'>
											<InputControl
												label='Confirm Password'
												name='confirmPass'
												state={confirmPass}
												type={confirmShowPassword ? 'text' : 'password'}
												onChange={(e) =>
													setConfirmPass(e.target.value.slice(0, limit))
												}
												errorMsg={invalidConfirmMsg && invalidConfirmMsg}
												error={invalidConfirmMsg?.length > 0}
												isErrorMsg={isError && isError}
												isError={isError?.length > 0}
											/>
											<IconButton
												className='toggle_btn'
												aria-label='toggle password visibility'
												onClick={handleClickConfirmShowPassword}
												edge='end'>
												{confirmShowPassword ? (
													<VisibilityOff />
												) : (
													<Visibility />
												)}
											</IconButton>
										</MarginHandler>
										<ButtonCom type='submit' btnTitle='Submit' />
									</form>
								</TabPanel>
							</SwipeableViews>
						</Box>
						<div className='custom_login_redirect_cover'>
							<Link to='/login' className='custom_login_redirect'>
								Login?
							</Link>
						</div>
					</div>
				</div>
			</div>
		</>
	);
};

export default ForgetPassword;
